import LightBox from "./imageview";

export const Image = ({ title, largeImage, smallImage, gallery = [] }) => {
  return (
    <div className='portfolio-item'>
      <div className='hover-bg'>
        {' '}
        <LightBox
          src={largeImage}
          alt={title}
          gallery={gallery}
        >
          <div className='hover-text'>
            <h4>{title}</h4>
          </div>
          <img
            src={smallImage}
            className='img-responsive'
            alt={title}
            style={{
              width: '100%',
              height: '250px',
              objectFit: 'cover',
              display: 'block',
            }}
          />{' '}
        </LightBox>{' '}
      </div>
    </div>
  )
}
